import { render } from "./TierFilter.vue?vue&type=template&id=aa0d80f0"
import script from "./TierFilter.vue?vue&type=script&lang=js"
export * from "./TierFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__